import React from 'react';
import MarkdownWithViz from '../../MarkdownWithViz';

const reqPrefix = 'src/markdowns/expenditure';
const req = require.context('!raw-loader!../../../markdowns/expenditure', false, /\.(md|jsx)$/);

export default function Expenditure() {
  return <MarkdownWithViz req={req} reqSource={req} reqPrefix={reqPrefix} />;
}
